import * as React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';

import { CheckIcon } from '@wkda/icons';

import * as styles from './CheckBox.module.scss';

/**
 * @param {Object} props
 * @param {boolean} props.isChecked
 * @param {string} props.className
 * @param {() => void} props.toggle
 * @param {string} [props.name]
 * @param {string} props.value
 */
export const CheckBox = ({ isChecked, className, toggle, name, value }) => (
  <div className={styles.wrapper}>
    <input
      name={name}
      className={cx(
        styles.checkBox,
        { [styles.checked]: isChecked },
        className,
      )}
      type="checkbox"
      checked={isChecked}
      onChange={toggle}
      value={value}
      data-qa-selector={`gdpr-banner-check-box-${value}`}
    />
    {isChecked ? <CheckIcon onClick={toggle} className={styles.icon} /> : null}
  </div>
);

CheckBox.propTypes = {
  name: PropTypes.string,
  isChecked: PropTypes.bool.isRequired,
  className: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};
